import styled from 'styled-components';

export const FormContainer = styled.div`
  && {
    background: #f2f2f2;
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const ModalWrapper = styled.div`
  padding: 24px;
`;

export const FormWrapper = styled.div`
  padding: 10px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
